import { openMediaPickerModal } from '../../services/mediaPickerModal';
import {
    applyBsImageMediaResult,
    resolveBsImageFigure,
    resolveBsImageImg,
} from '../../blocks/bootstrap-components/components/imageCaption';

export default (editor, config = {}) => {
    const tm = editor.TraitManager;

    tm.addType('media-library-select', {
        noLabel: true,
        createInput({ trait }) {
            const component = trait.target;
            const componentType = component.get('type');
            const imageTarget = resolveBsImageImg(component) || component;
            const figure = resolveBsImageFigure(component) || resolveBsImageFigure(imageTarget);

            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = 'Bild ändern';
            button.className = 'gjs-btn-prim';
            button.style.cssText =
                'width:100%;margin:4px 0;padding:8px 12px;font-size:13px;cursor:pointer;background:#0991b2;color:#fff;border:none;border-radius:4px;';

            button.addEventListener('click', () => {
                openMediaPickerModal({
                    allowedTypes: ['image'],
                    title: 'Bild auswählen',
                }).then((result) => {
                    if (!result?.url) return;
                    if (componentType === 'image-box') {
                        component.set('background-image', result.url);
                        component.trigger('change:background-image');
                        return;
                    }

                    applyBsImageMediaResult({ imageTarget, figure, result });
                });
            });

            return button;
        },
    });
};
